import { a as m, j as r } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as e } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import { b as w, f as v, T as k } from "../../../FeatureFlagProvider-DSFeeZ8R.js";
import "react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function $(t) {
  const {
    label: i,
    description: a,
    value: d,
    isSelected: s,
    status: p = "enabled",
    hasTextField: u,
    onChange: I,
    groupName: h,
    "data-testid": g
  } = t, n = p === "disabled", l = p === "readOnly";
  function x() {
    p === "enabled" && I(d);
  }
  return /* @__PURE__ */ m("label", {
    "data-testid": g ? `${g}-${d}` : h ? `${h}-${d}` : void 0,
    css: o.container({
      isDisabled: n,
      isReadOnly: l
    }),
    children: [/* @__PURE__ */ r("input", {
      name: h,
      type: "radio",
      value: d,
      checked: s,
      onChange: x,
      disabled: n,
      readOnly: l,
      "aria-label": i,
      css: o.hiddenInput
    }), /* @__PURE__ */ r("div", {
      css: o.radioWrapper,
      children: /* @__PURE__ */ r("div", {
        css: o.radioOuter({
          isDisabled: n,
          isReadOnly: l,
          isSelected: s
        }),
        children: /* @__PURE__ */ r("div", {
          css: o.radioInner({
            isSelected: s,
            isDisabled: n,
            isReadOnly: l
          })
        })
      })
    }), /* @__PURE__ */ m("div", {
      css: {
        color: n ? e.slate300 : e.black,
        width: "100%"
      },
      children: [/* @__PURE__ */ r("p", {
        css: {
          ...w(),
          margin: 0
        },
        children: i
      }), a && /* @__PURE__ */ r("p", {
        css: {
          margin: 0,
          ...v()
        },
        children: a
      }), u && s && /* @__PURE__ */ r("div", {
        css: {
          paddingTop: 16
        },
        children: /* @__PURE__ */ r(k, {
          ...u
        })
      })]
    })]
  });
}
const c = 18, b = 3, f = 9, o = {
  container: ({
    isDisabled: t,
    isReadOnly: i
  }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    padding: "16px 24px",
    background: e.white200,
    cursor: t || i ? "not-allowed" : "pointer",
    transition: "background-color 0.2s ease",
    ":hover": !t && !i ? {
      background: e.white300
    } : {}
  }),
  // Use the "visually hidden" pattern to hide the native radio input
  // while preserving keyboard accessibility and screen reader support.
  hiddenInput: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0
  },
  radioWrapper: {
    width: c + b * 2,
    // Total width 24px
    height: c + b * 2,
    // Total height 24px
    padding: b,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  radioOuter: ({
    isDisabled: t,
    isReadOnly: i,
    isSelected: a
  }) => ({
    width: c,
    height: c,
    borderRadius: "50%",
    boxSizing: "border-box",
    border: `2px solid ${t ? e.slate300 : i ? e.black : e.blue500}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    transition: "border-color 0.2s ease",
    position: "relative",
    ...a && !t ? {
      ":hover": {
        background: e.white300
      }
    } : {}
  }),
  radioInner: ({
    isSelected: t,
    isDisabled: i,
    isReadOnly: a
  }) => ({
    width: f,
    height: f,
    borderRadius: "50%",
    backgroundColor: t ? i ? e.slate300 : a ? e.black : e.blue500 : e.white200,
    position: "absolute",
    top: "50%",
    left: "50%",
    transition: "transform 280ms cubic-bezier(0.4, 0, 0.2, 1) 0s",
    transform: t ? "translate(-50%, -50%) scale3d(1, 1, 1)" : "translate(-50%, -50%) scale3d(0, 0, 0)"
  })
};
export {
  $ as RadioInput
};
